import { render, staticRenderFns } from "./AsiLoginForm.vue?vue&type=template&id=4ed43bf2&scoped=true"
import script from "./AsiLoginForm.vue?vue&type=script&lang=ts"
export * from "./AsiLoginForm.vue?vue&type=script&lang=ts"
import style0 from "./AsiLoginForm.vue?vue&type=style&index=0&id=4ed43bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed43bf2",
  null
  
)

export default component.exports